<template lang="html">
    <div class="px-4 py-5 sm:p-6 stat" :class="{'flex-1': sameWidth}">
        <dt class="text-sm font-normal">{{ name }}</dt>
        <dd class="mt-1 flex items-baseline md:block lg:flex">
            <div class="flex items-baseline text-xl sm:text-2xl md:text-3xl font-semibold">
              <external-link v-if="valueLink?.length > 0" :link="valueLink" :text="value"/>
              <span v-if="!valueLink || valueLink?.length < 0">{{ value }}</span>
            </div>
            <div v-if="secondValue" class="flex items-baseline text-xl font-semibold ml-3">
                {{ secondValue }}
            </div>

            <!--
            <div class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium bg-green-100 text-green-800 md:mt-2 lg:mt-0">
                <svg class="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                </svg>
                <span class="sr-only"> Increased by </span>
                12%
            </div>
            -->
        </dd>
    </div>
</template>

<script>
import ExternalLink from "@/Shared/ExternalLink";

export default {
    components: {
      ExternalLink,
    },
    props: {
        name: {
            type: String
        },
        value: {
            default: null
        },
        secondValue: {
            default: null
        },
        sameWidth: {
            type: Boolean,
            default: false
        },
        valueLink: String
    }
}
</script>
